<main>
  <loading-overlay [isLoading]="loading"></loading-overlay>
  <p-confirmDialog></p-confirmDialog>
  <header>
    <div class="headline">
      <h1>
        {{ 'Shipment_Details_Title' | translateWF: 'Shipment' }}:
        {{ shipment ? shipment.shipmentNumber : ('Shipment_Details_Title_New' | translateWF: 'Shipment New') }}
      </h1>
      <csl-dropdown [enumObject]="statusEnumObject" [enumValueOptions]="shipmentStatusOptions" [formControl]="status" enumName="ShipmentStatus" />
    </div>
    <div class="buttons">
      <p-button *ngIf="shipment ? shipment!.status < 5 : true" [label]="'Save' | translateWF: 'Save'" (click)="save()" [disabled]="!canEdit()" />
      <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <form [formGroup]="shipmentForm" class="col">
      <div class="grid-auto-4">
        <p-panel [header]="'Shipment_Details_General_Information' | translateWF: 'General Information'">
          <p-card>
            <div class="col">
              <div class="form-box">
                <label for="">{{ 'Shipment_Segment_Date_Created' | translateWF: 'Created Date' }}</label>
                <p-datepicker fluid class="w-full disabled-ui" formControlName="createdDate" [iconDisplay]="'input'" [showIcon]="true" />
              </div>
              <div class="form-box">
                <label for="">{{ 'Shipment_Segment_Shipment_Type' | translateWF: 'Incoming Shipment Type' }}</label>
                <p-select fluid class="w-full" formControlName="shipmentType" [options]="setOptionsForPrimeNg(shipmentTypeOptions)" [disabled]="editing" />
              </div>
              <div class="form-box">
                <label for="">{{ 'Shipment_Details_Tracking' | translateWF: 'Tracking' }}</label>
                <input type="text" class="p-inputtext p-component w-full" formControlName="trackingNumber" />
              </div>
              <div class="form-box">
                <label for="">{{ 'Shipment_Details_Shipment_Date' | translateWF: 'Shipment Date' }}</label>
                <p-datepicker fluid class="w-full" formControlName="shipmentDate" [iconDisplay]="'input'" [showIcon]="true" />
              </div>
            </div>
          </p-card>
        </p-panel>

        <p-panel [header]="'Shipment_Details_Duca' | translateWF: 'Duca'">
          <p-card>
            @if (!shipment?.id) {
              <p-message severity="secondary">{{
                'Shipment_Details_Save_To_Upload_Duca'
                  | translateWF
                    : 'Please save
              shipment to upload DUCA'
              }}</p-message>
            } @else {
              <div>
                <div class="w-full">
                  <input type="file" class="hidden" #ducaInput (change)="onFileSelected($event, 'Duca')" />
                  <p-button
                    fluid
                    class="border-dashed bg-none w-full"
                    (click)="ducaInput.click()"
                    [label]="'Shipment_Details_Upload_Browser_Duca' | translateWF: 'Upload Browser DUCA'"
                    [disabled]="!canEdit()"
                    variant="outlined"
                  />
                </div>

                <div class="duca-card w-full p-3 rounded-lg bg-[#a7fff947] border border-gray-400 text-end mt-3">
                  <div class="form-box-row">
                    <p>{{ 'Shipment_Details_Duca_No' | translateWF: 'No. of DUCA:' }}</p>
                    <p class="truncate">
                      <b>{{ ducaInfoForm.controls.ducaNumber.value }}</b>
                    </p>
                  </div>
                  <a (click)="openDucaModal()">{{ 'Shipment_Details_Charge_URL' | translateWF: 'Charge URL' }}</a>
                </div>

                <ul class="duca-list mt-4">
                  @for (file of [this.shipment?.duca]; track $index) {
                    @if (file) {
                      <li class="w-full row-between-center px-3 py-1 mb-3 bg-[#5aa29d70] border border-gray-400 rounded-lg cursor-pointer" (click)="viewFile(file.presignedUrl)">
                        <a class="file-name">{{ getFileName(file.name) }}</a>
                        @if (canEdit()) {
                          <p-button icon="pi pi-times" variant="text" (click)="deleteFileShipment($index, file, 'Duca'); $event.stopPropagation()" />
                        }
                      </li>
                    }
                  }
                </ul>
              </div>
            }
          </p-card>
        </p-panel>

        <p-panel [header]="'Shipment_Details_Packing_List' | translateWF: 'Packing List: Uploaded'">
          <p-card>
            @if (!shipment?.id) {
              <p-message severity="secondary">{{
                'Shipment_Details_Save_To_Upload_Files'
                  | translateWF
                    : 'Please save
              shipment to upload files'
              }}</p-message>
            } @else {
              <div class="">
                <div class="w-full">
                  <input type="file" #packingListInput class="hidden" accept="*/*" (change)="onFileSelected($event, 'PakingList')" />
                  <p-button
                    fluid
                    class="border-dashed bg-none w-full"
                    (click)="packingListInput.click()"
                    [label]="'Shipment_Details_Browse_Packing_Files' | translateWF: 'Browse Packing Files'"
                    variant="outlined"
                    [disabled]="!canEdit()"
                  />
                </div>

                <p-scrollpanel [style]="{ width: '100%', height: '250px' }">
                  <div class="upload-file-container">
                    @for (file of this.shipment?.packingList; track $index) {
                      <div class="file-item" (click)="viewFile(file.presignedUrl)">
                        <p class="truncate">{{ getFileName(file.name) }}</p>
                        @if (canEdit()) {
                          <p-button icon="pi pi-times" variant="text" (click)="deleteFileShipment($index, file, 'PakingList'); $event.stopPropagation()" />
                        }
                      </div>
                    }
                  </div>
                </p-scrollpanel>
              </div>
            }
          </p-card>
        </p-panel>

        <p-panel [header]="'Shipment_Details_Attachments' | translateWF: 'Attachments'">
          <p-card>
            @if (!shipment?.id) {
              <p-message severity="secondary">{{
                'Shipment_Details_Save_To_Upload_Files'
                  | translateWF
                    : 'Please save
              shipment to upload files'
              }}</p-message>
            } @else {
              <div class="">
                <div class="w-full">
                  <input type="file" class="hidden" accept="*/*" #file (change)="onFileSelected($event, 'Files')" />
                  <p-button
                    fluid
                    class="border-dashed bg-none w-full"
                    (click)="file.click()"
                    [label]="'Shipment_Details_Upload_Browser_Files' | translateWF: 'Upload Browser Files'"
                    variant="outlined"
                    [disabled]="!canEdit()"
                  />
                </div>

                <p-scrollpanel [style]="{ width: '100%', height: '250px' }">
                  <div class="upload-file-container">
                    @for (file of this.shipment?.files; track $index) {
                      <div class="file-item" (click)="viewFile(file.presignedUrl)">
                        <p class="truncate">{{ getFileName(file.name) }}</p>
                        @if (canEdit()) {
                          <p-button icon="pi pi-times" variant="text" click="deleteFileShipment($index, file, 'Files'); $event.stopPropagation()" />
                        }
                      </div>
                    }
                  </div>
                </p-scrollpanel>
              </div>
            }
          </p-card>
        </p-panel>
      </div>

      @if (editing) {
        <!-- Invoice Selection for Standard Shipments -->
        <p-panel [header]="'Purchase_Order_Details_Invoices' | translateWF: 'Invoice(s)'" *ngIf="!isConsignmentMode">
          <ng-template pTemplate="icons">
            <span
              class="pi pi-info-circle cursor-pointer"
              pTooltip="{{ 'Shipment_Details_Search_Invoices' | translateWF: 'Search for invoices to add to shipment' }}"
              tooltipPosition="left"
            ></span>
          </ng-template>

          <p-card>
            <div class="form-box">
              <div class="input-wrapper">
                <p-autoComplete
                  [dropdown]="true"
                  class="w-full"
                  dropdownIcon="pi pi-search"
                  [suggestions]="filteredInvoices"
                  field="invoiceNumber"
                  (completeMethod)="optionsInvoices($event)"
                  [formControl]="searchInvoice"
                />
              </div>
            </div>

            <div class="row">
              <ul class="invoice-list-selection">
                @if (selectedInvoices.length > 0) {
                  @for (invoice of selectedInvoices; track $index) {
                    <li (click)="openModalInvoice(invoice)">
                      <div class="text">
                        <span>#{{ $index + 1 }}</span>
                        <p>{{ invoice.invoiceNumber }}</p>
                      </div>
                      @if (canRemoveInvoice(invoice)) {
                        <p-button icon="pi pi-times" variant="text" (click)="removeInvoiceAtList(invoice.id!); $event.stopPropagation()" />
                      }
                    </li>
                  }
                } @else if (!selectedInvoices.length && !purchaseOrder.value) {
                  <li>
                    {{
                      'Shipment_Details_Select_Purchase_Order'
                        | translateWF
                          : 'Select a purchase order to link to its
                invoices'
                    }}
                  </li>
                } @else {
                  <li>{{ 'Shipment_Details_No_Invoices_Selected' | translateWF: 'No invoices selected' }}</li>
                }
              </ul>
            </div>
          </p-card>
        </p-panel>

        <!-- Delivery Note Selection for Consignment Shipments -->
        <p-panel [header]="'Shipment_Details_Delivery_Notes' | translateWF: 'Delivery Note(s)'" *ngIf="isConsignmentMode">
          <ng-template pTemplate="icons">
            <span
              class="pi pi-info-circle cursor-pointer"
              pTooltip="{{ 'Shipment_Details_Search_Delivery_Notes' | translateWF: 'Search for delivery notes to add to shipment' }}"
              tooltipPosition="right"
            ></span>
          </ng-template>
          <p-card>
            <div class="form-box">
              <div class="input-wrapper">
                <p-autoComplete
                  [dropdown]="true"
                  class="w-full"
                  dropdownIcon="pi pi-search"
                  [suggestions]="filteredDeliveryNotes"
                  field="number"
                  (completeMethod)="optionsDeliveryNotes($event)"
                  [formControl]="searchDeliveryNote"
                />
              </div>
            </div>

            <div class="row">
              <ul class="invoice-list-selection">
                @if (selectedDeliveryNotes.length > 0) {
                  @for (deliveryNote of selectedDeliveryNotes; track $index) {
                    <li (click)="openModalDeliveryNote(deliveryNote)">
                      <div class="text">
                        <span>#{{ $index + 1 }}</span>
                        <p>{{ deliveryNote.number }}</p>
                      </div>
                      <p-button icon="pi pi-times" variant="text" (click)="removeDeliveryNoteAtList(deliveryNote.id!); $event.stopPropagation()" />
                    </li>
                  }
                } @else {
                  <li>{{ 'Shipment_Details_No_Delivery_Notes_Selected' | translateWF: 'No delivery notes selected' }}</li>
                }
              </ul>
            </div>
          </p-card>
        </p-panel>

        <p-panel [header]="'Shipment_Details_Costs' | translateWF: 'Costs'" *ngIf="!isConsignmentMode">
          <p-card>
            <div class="grid-auto-4">
              <div class="form-box">
                <label for="shipmentCost" class="required whitespace-nowrap min-w-[120px]">{{ 'Shipment_Details_Shipment_Cost' | translateWF: 'Shipment Cost' }}</label>
                <p-inputgroup class="flex-1">
                  <p-inputnumber
                    inputId="shipmentCost"
                    formControlName="shipmentCost"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    placeholder="0.00"
                    [disabled]="!canEdit()"
                    class="flex-1"
                  />
                  <p-inputGroupAddon>$</p-inputGroupAddon>
                </p-inputgroup>
              </div>
              <div class="form-box">
                <label for="insuranceCost" class="required whitespace-nowrap min-w-[120px]">{{ 'Shipment_Details_Insurance_Cost' | translateWF: 'Insurance Cost' }}</label>
                <p-inputgroup class="flex-1">
                  <p-inputnumber
                    inputId="insuranceCost"
                    formControlName="insuranceCost"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    placeholder="0.00"
                    [disabled]="!canEdit()"
                    class="flex-1"
                  />
                  <p-inputGroupAddon>$</p-inputGroupAddon>
                </p-inputgroup>
              </div>
            </div>
          </p-card>
        </p-panel>

        <p-panel [header]="'Shipment_Details_Lots' | translateWF: 'Lots'">
          <ng-template pTemplate="icons">
            @if (canEditLots()) {
              <div class="row-start-center">
                <p-button variant="outlined" [label]="'Shipment_Details_Save_Lots' | translateWF: 'Save Lots'" (click)="saveLots()" />
                <p-button
                  #addLotsBtn
                  icon="pi pi-plus"
                  [label]="'Shipment_Details_Add_Lots' | translateWF: 'Add Lots'"
                  variant="outlined"
                  (click)="onAddLotsClick()"
                  [disabled]="!allowToAddLots"
                  [pTooltip]="addLotsTooltip"
                  tooltipPosition="top"
                />
              </div>
            }
          </ng-template>

          @if (!isConsignmentMode) {
            <div class="list-lots">
              <p-accordion *ngIf="selectedInvoices.length && showLotItemsTable()">
                <p-accordionTab *ngFor="let invoice of selectedInvoices; let i = index">
                  <ng-template pTemplate="header">
                    <span>{{ 'Invoice_Details_Title' | translateWF: 'Invoice' }} - {{ invoice.invoiceNumber }}</span>
                  </ng-template>

                  <p-table [value]="getLotsByInvoice(invoice?.id)" class="standard" [scrollable]="true" scrollHeight="400px">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>{{ 'Shipment_Details_Lot_ID' | translateWF: 'Lot ID' }}</th>

                        <th>PO Number</th>
                        <th>{{ 'Shipment_Details_Packaging_Type' | translateWF: 'Packaging Type' }}</th>
                        <th>{{ 'Shipment_Details_Manufacturer_Label_ID' | translateWF: 'Manufacturer Label ID' }}</th>
                        <th>{{ 'Shipment_Details_Manufacturer_Lot_ID' | translateWF: 'Manufacturer Lot Number' }}</th>
                        <th>{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}</th>
                        <th>{{ 'Purchase_Order_Details_Item_Description' | translateWF: 'Item Description' }}</th>

                        <th>{{ 'Shipment_Details_Gross_Qty' | translateWF: 'Gross Qty' }}</th>
                        <th>{{ 'Shipment_Details_Net_Qty' | translateWF: 'Net Qty' }}</th>
                        <th></th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-lot>
                      <tr>
                        @let lotItem = strictLotItem(lot);
                        <td>{{ lotItem.number }}</td>
                        <td>{{ lotItem.purchaseOrder?.purchaseOrderNumber }}</td>
                        <td>{{ getPackagingType(lotItem.packagingType) }}</td>
                        <td>{{ lotItem.providerLabelNumber }}</td>
                        <td>{{ lotItem.providerLotId }}</td>
                        <td>{{ lotItem.itemCode }}</td>
                        <td>{{ lotItem.item?.itemDisplayName?.en }}</td>
                        <td>{{ lotItem.originalGrossQuantity | number: '1.2-2' }}</td>
                        <td>{{ lotItem.originalNetQuantity | number: '1.2-2' }}</td>
                        <td>
                          @if (canDelete(lot) && canEditLots()) {
                            <p-button severity="danger" variant="text" icon="pi pi-trash" (click)="deleteLotItemConsignment(lotItem.id!)" />
                          } @else {
                            <span *ngIf="isReceived(lot)" class="pi pi-check text-green-500"></span>
                          }
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                      <tr>
                        <td colspan="7" class="text-right font-bold">{{ 'Total' | translateWF: 'Total' }}</td>
                        <td class="font-bold">
                          {{ getTotalGrossQuantity(invoice.id!) | number: '1.2-2' }}
                        </td>
                        <td class="font-bold">
                          {{ getTotalNetQuantity(invoice.id!) | number: '1.2-2' }}
                        </td>
                        <td colspan="1" class="text-right font-bold"></td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-accordionTab>
              </p-accordion>
            </div>
          } @else {
            <p-card data-variant="compact">
              <p-table [value]="getConsignmentLots()" class="standard" [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ 'Shipment_Details_Lot_ID' | translateWF: 'Lot ID' }}</th>
                    <th>{{ 'Shipment_Details_Packaging_Type' | translateWF: 'Packaging Type' }}</th>
                    <th>{{ 'Shipment_Details_Manufacturer_Label_ID' | translateWF: 'Manufacturer Label ID' }}</th>
                    <th>{{ 'Shipment_Details_Manufacturer_Lot_ID' | translateWF: 'Manufacturer Lot Number' }}</th>
                    <th>{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}</th>
                    <th>{{ 'Purchase_Order_Details_Item_Description' | translateWF: 'Item Description' }}</th>

                    <th>{{ 'Shipment_Details_Gross_Qty' | translateWF: 'Gross Qty' }}</th>
                    <th>{{ 'Shipment_Details_Net_Qty' | translateWF: 'Net Qty' }}</th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-lot>
                  <tr>
                    <td>{{ lot.number }}</td>

                    <td>{{ getPackagingType(lot.packagingType) }}</td>
                    <td>{{ lot.providerLabelNumber }}</td>
                    <td>{{ lot.providerLotId }}</td>
                    <td>{{ lot.itemCode }}</td>
                    <td>{{ lot.item?.itemDescription | localized }}</td>
                    <td>{{ lot.originalGrossQuantity | number: '1.2-2' }}</td>
                    <td>{{ lot.originalNetQuantity | number: '1.2-2' }}</td>
                    <td>
                      @if (canDelete(lot) && canEditLots()) {
                        <p-button severity="danger" variant="text" icon="pi pi-trash" (click)="deleteLotItemConsignment(lot.number!)" />
                      }
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                  <tr>
                    <td colspan="6" class="text-right font-bold">{{ 'Total' | translateWF: 'Total' }}</td>
                    <td class="font-bold">
                      {{ getTotalQuantitiesConsignment().totalGross | number: '1.2-2' }}
                    </td>
                    <td class="font-bold">
                      {{ getTotalQuantitiesConsignment().totalNet | number: '1.2-2' }}
                    </td>
                    <td colspan="1" class="text-right font-bold"></td>
                  </tr>
                </ng-template>
              </p-table>
            </p-card>
          }
        </p-panel>
      }
    </form>
  </div>
</main>
